"use strict";
/**
 * 一些默认的样式配置
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKGROUND_STYLE = {
    fill: '#416180 ',
    opacity: 0.05,
};
exports.FOREGROUND_STYLE = {
    fill: '#5B8FF9',
    opacity: 0.15,
    cursor: 'move',
};
exports.DEFAULT_HANDLER_WIDTH = 10;
exports.HANDLER_STYLE = {
    width: exports.DEFAULT_HANDLER_WIDTH,
    height: 24,
};
exports.TEXT_STYLE = {
    textBaseline: 'middle',
    fill: '#000',
    opacity: 0.45,
};
exports.SLIDER_CHANGE = 'sliderchange';
//# sourceMappingURL=constant.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/gui/lib/slider/constant.js
// module id = 1050
// module chunks = 37